import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import ProductReleasesTable from './ProductReleasesTable';
import ProductReleaseDetail from './ProductRelease';

class ProductReleases extends PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired
  };

  render() {
    const { match } = this.props;
    return (
      <div className="product-releases-wrapper mt-3">
        <Switch>
          <Route exact path={match.path} component={ProductReleasesTable} />
          <Route path={`${match.path}/:id`} component={ProductReleaseDetail} />
        </Switch>
      </div>
    );
  }
}

export default ProductReleases;
